!function() {
  "use strict";
  customElements.get("country-selector") || customElements.define("country-selector", class extends HTMLElement {
    constructor() {
      super(), this.form = this.querySelector("form"), this.currentStore = this.dataset.storeCode;
    }
    connectedCallback() {
      this.form && window.Geo && this.addEventListeners();
    }
    updateCountry() {
      const selected = this.querySelector('[name="country_code"]').selectedOptions[0];
      selected ? (this.querySelector("[data-name]") && (this.querySelector("[data-name]").textContent = selected.textContent), 
      this.querySelector("[data-flag]") && (this.querySelector("[data-flag]").src = this.querySelector("[data-flag]").src.replace(/([a-z]{2})\.svg$/, `${selected.value.toLowerCase()}.svg`))) : this.form.submit();
    }
    setCountry() {
      let countryCode = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
      countryCode = countryCode || this.form.querySelector('[name="country_code"]').value.trim().toUpperCase();
      const store = Shopify.MultiStore.find((s => s.supportedCountries.includes(countryCode)));
      store && (window.Geo.setGeolocationCookie(countryCode), store.storeCode !== this.currentStore) ? location.href = `${store.storeUrl}${location.pathname || "/"}?${location.search}&country=${countryCode.toUpperCase()}` : this.form.submit();
    }
    addEventListeners() {
      this.form.addEventListener("change", (() => {
        this.updateCountry();
      })), this.form.addEventListener("submit", (event => {
        event.preventDefault(), this.setCountry();
      })), this.querySelectorAll("[data-close]").forEach((el => {
        Shopify.country && el.addEventListener("click", (event => {
          event.preventDefault(), this.setCountry(Shopify.country);
        }));
      }));
    }
  });
}();